import InsightsHub from '@assets/icons/insights-hub.svg';
import React from 'react';
import { BadgeAbsolute } from '@/components/badge-absolute';
import { createStyles } from '@/contexts/theme-context';
import { StyleProp, View, ViewStyle } from 'react-native';
import { useUnseenAlertsIndicator } from '@/hooks/insights-hub/use-unseen-alerts-indicator';

interface Props {
  badgeStyle?: StyleProp<ViewStyle>;
  salesRepModeEnabled: boolean;
}

export const InsightsHubIcon: React.FC<Props> = ({
  badgeStyle,
  salesRepModeEnabled,
}) => {
  const [styles, theme] = useStyles();
  const { showAlertsIndicator } = useUnseenAlertsIndicator();

  return (
    <View collapsable={false}>
      <InsightsHub
        accessibilityLabel="insights-hub-icon"
        stroke={
          salesRepModeEnabled ? theme.colors.white : theme.colors.secondary
        }
      />

      {showAlertsIndicator ? (
        <BadgeAbsolute badgeStyle={[styles.badge, badgeStyle]} />
      ) : null}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  badge: {
    backgroundColor: theme.sk.color.bg.system.badge,
    margin: 1,
    top: -5,
  },
}));
